import retry from '@/utils/retry';
import { MESSAGES } from '../utils/messages';
import { notifyError } from '../../module_user/uitls/notification-helper';
import redirect from '../../module_user/uitls/redirect';
import eliteService from '../../module_user/api/elite-service';
import api from '../api/api';
import { compareDates, getWorkoutVideoDetails, getMyVideoList, getChallengeEndTime, getFormattedDate } from "../utils/genericFunctions";

const getState = () => {
    return {
        tenantData: null,
        videoList: [],
        trainerDataLoading: false,
        isChallengePage: true,
        selectedChallengeIndex: null,
        corporatePrograms: [],
        isMyWorkout: true,
        nextPlayListId: null,
        nextPlayListTenantName: null,
        isCorporate: false,
        friendsActivityData: [],
        isCreateHistory: false,
        isDeleteHistory: false,
    };
}
const state = getState();

const mutations = {
    setTenant(state, data) {
        state.tenantData = data;
    },

    setIsCorporate(state, data) {
        state.isCorporate = data;
    },

    setLoading(state, data) {
        state.trainerDataLoading = data;
    },
    setIsCreateHistory(state, isCreateHistory) {
        state.isCreateHistory = isCreateHistory;
    },

    setIsDeleteHistory(state, isDeleteHistory) {
        state.isDeleteHistory = isDeleteHistory;
    },
    setChallengePage(state, isChallengePage) {
        state.isChallengePage = isChallengePage;
    },
    setSelectedChallengeIndex(state, selectedChallengeIndex) {
        state.selectedChallengeIndex = selectedChallengeIndex;
    },
    setCorporatePrograms(state, corporatePrograms) {
        state.corporatePrograms = corporatePrograms;
    },
    setIsMyWorkout(state, isMyWorkout) {
        state.isMyWorkout = isMyWorkout;
    },
    setNextPlayListId(state, nextPlayListId) {
        state.nextPlayListId = nextPlayListId
    },
    setNextPlayListTenantName(state, nextPlayListTenantName) {
        state.nextPlayListTenantName = nextPlayListTenantName
    },
    setFriendsActivity(state, data) {
        state.friendsActivityData = data
    }
};

const getters = {
    getActiveVideos(state) {
        return state.corporatePrograms.filter((video) => !video.isUpcoming);
    },
    getAllChallengesList(state, getters) {
        return getters.getActiveVideos.filter( item => item.totalWorkouts > 0 && (!item.lastWorkoutTried || getChallengeEndTime(getFormattedDate(item.programEndDate), false) == "This challenge has expired." || item.totalWorkouts == item.completedWorkouts))
    },
    getMyVideoList(state, getters) {
        return getMyVideoList([...getters.getActiveVideos], 3);
    },
    getChallengeList(state, getters) {
        return state.isMyWorkout ? getters.getMyVideoList : getters.getAllChallengesList;
    },
    getSelectedProgressWorkout(state, getters) {
        if (state.isMyWorkout) {
            return getters.getMyChallenges[state.selectedChallengeIndex];
        }
        else {
            return getters.getAllChallenges[state.selectedChallengeIndex];
        }
    },
    getAllChallenges(state, getters) {
        return getters.getAllChallengesList.map(getWorkoutVideoDetails);
    },

    getCompletedChallenges(state, getters) {
        return getters.getActiveVideos.map(getWorkoutVideoDetails).filter( item =>  item.totalWorkouts > 0 && item.totalWorkouts == item.completedWorkouts);
    },
    getExpiredChallenges(state, getters) {
        return getters.getActiveVideos.map(getWorkoutVideoDetails).filter( item =>  item.totalWorkouts > 0 && getChallengeEndTime(item.toDate, false) == "This challenge has expired.");
    },

    getMyChallenges(state, getters) {
        return getters.getMyVideoList.map(getWorkoutVideoDetails);
    },
    getStartWorkoutLabel(state, getters) {
        if (getters.getSelectedProgressWorkout?.completedWorkouts == 0) {
            return "START CHALLENGE";
        } else {
            return "CONTINUE CHALLENGE";
        }
    },

};

const actions = {
    async loadTenantData({ commit ,rootState}, tenantName) {
        commit('setLoading', true);
        let userData = rootState.userInfo
        if (tenantName === '' && userData?.corporate) {
            tenantName = userData.corporate?.redirect_url ? userData.corporate?.redirect_url : userData?.corporate?.organization;
        }
        try {
            const data = await eliteService.getTenantData(tenantName);
            commit('setTenant', data);
            if (data?.isCorporate) {
                commit('setIsCorporate', data.isCorporate)
            }
            commit('setLoading', false);
            return data;
        }
        catch (e) {
            try {
                await retry(e);
                const data = await eliteService.getTenantData(tenantName);
                commit('setTenant', data);
                commit('setLoading', false);
                return data;
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        }
        finally{
            commit('setLoading', false);
        };
    },
    async createProgramHistory({ commit }, {assignedId, type}) {
        commit('setLoading', true);
        commit('setIsCreateHistory', false);
        try {
            const programs = await api.createProgramHistory({assignedId, type});
            if (programs.code === 200) {
                commit('setIsCreateHistory', true);
            }
            commit('setLoading', false);
        }
        catch (e) {
            try {
                await retry(e);
                const programs = await api.createProgramHistory({assignedId, type});
                if (programs.code === 200) {
                    commit('setIsCreateHistory', true);
                }
                commit('setLoading', false);
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_USER_HISTORY_FAILED);
                Promise.reject(e);
            }
        }
        finally{
            commit('setLoading', false);
        };
    },
    async deleteProgramHistory({ commit }, program_id) {
        commit('setLoading', true);
        commit('setIsDeleteHistory', false);
        try {
            const programs = await api.deleteProgramHistory(program_id);
            if (programs.code === 200) {
                commit('setIsDeleteHistory', true);
            }
            commit('setLoading', false);
        }
        catch (e) {
            try {
                await retry(e);
                const programs = await api.deleteProgramHistory(program_id);
                if (programs.code === 200) {
                    commit('setIsDeleteHistory', true);
                }
                commit('setLoading', false);
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_USER_HISTORY_FAILED);
                Promise.reject(e);
            }
        }
        finally{
            commit('setLoading', false);
        };
    },
    async loadCorporatePrograms({ commit }, data) {
        commit('setLoading', true);
        try {
            const programs = await api.getCorporateProgram({
                id: data && data.id ? data.id : data,
                type : data && data.type ? data.type : 'all'
            });
            if (programs.code === 200) {
                commit('setCorporatePrograms', programs.data);
            }
            commit('setLoading', false);
        }
        catch (e) {
            try {
                await retry(e);
                const programs = await api.getCorporateProgram({
                    id: id && id.id ? id.id : id,
                    type : id && id.type ? id.type : 'all'
                });
                if (programs.code === 200) {
                    commit('setCorporatePrograms', programs.data);
                }
                commit('setLoading', false);
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_CHALLENGE_FAILED);
                Promise.reject(e);
            }
        }
        finally{
            commit('setLoading', false);
        };
    },
    setChallengePage({ commit }, isChallengePage) {
        commit('setChallengePage', isChallengePage);
    },
    setSelectedChallengeIndex({ commit }, selectedChallengeIndex) {
        commit('setSelectedChallengeIndex', selectedChallengeIndex);
    },
    setIsMyWorkout({ commit }, isMyWorkout) {
        commit('setIsMyWorkout', isMyWorkout);
    },
    setNextPlayListId({ commit }, nextPlayListId) {
        commit('setNextPlayListId', nextPlayListId);
    },
    setNextPlayListTenantName({ commit }, nextPlayListTenantName) {
        commit('setNextPlayListTenantName', nextPlayListTenantName);
    },
    setNextWorkoutId({ commit, state, getters }) {
        // console.log("current challeng: ", state.selectedChallengeIndex, getters.getChallengeList[state.selectedChallengeIndex])
        getters.getChallengeList[state.selectedChallengeIndex].videos.every(
            (workout) => {
                if (!state.nextPlayListId && !workout.isCompleted) {
                    commit("setNextPlayListId", workout.id);
                    commit("setNextPlayListTenantName", workout.tenantOrganization);
                    return false;
                }
                return true;
            }
        );
        if (state.nextPlayListId) {
            // this.goToVideo();
        } else {
            if (getters.getChallengeList.length > 0) {
                commit("setNextPlayListId", getters.getChallengeList[0].id);
                commit("setNextPlayListTenantName",
                    getters.getChallengeList[0].tenantOrganization
                );
            }
        }
    },
    selectChallenge({commit, dispatch}, index) {
        commit('setNextPlayListId', null);
        commit("setSelectedChallengeIndex", index);
        commit("setChallengePage", false);
        dispatch("setNextWorkoutId");
    },

    async loadTeamsActivity ({ commit }) {
        commit('setLoading', true);
        try {
            const data = await eliteService.getTeamsActivityData();
            commit('setFriendsActivity', data.data);
            commit('setLoading', false);
            return data;
        }
        catch (e) {
            try {
                await retry(e);
                const data = await eliteService.getTeamsActivityData();
                commit('setFriendsActivity', data.data);
                commit('setLoading', false);
                return data;
            } catch {
                redirect(e);
                Promise.reject(e);
            }
        };
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
